// These are the provider and client short ids we use for testing
export const syntheticShortIds = ['a0uymx1mtze3', 'vqrn0zilextg', 'cu5wgqh0ughi', 's6yh74u4ffom'];
